import 'css-chunk:src/feature/provision/ClaimTerminal.module.scss';export default {
  "notice": "ClaimTerminal_notice"
};